import React, { useState, useEffect } from 'react';
import { incomeAPI } from '../../api';
import LoadingSpinner from '../LoadingSpinner';

const UserIncome = () => {
  const [incomes, setIncomes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchIncomes();
  }, []);

  const fetchIncomes = async () => {
    try {
      setLoading(true);

      const response = await incomeAPI.getMyIncome();

      const payload = response?.data;

      // Support both API formats:
      // 1) Old: response.data = []
      // 2) New: response.data = { incomes: [], totalRecords, totalPages, currentPage }
      if (Array.isArray(payload)) {
        setIncomes(payload);
      } else if (Array.isArray(payload?.incomes)) {
        setIncomes(payload.incomes);
      } else {
        setIncomes([]);
      }

      setError('');
    } catch (err) {
      // If no income found (404), don't show error
      if (err.response?.status === 404) {
        setIncomes([]);
        setError('');
      } else {
        setError('Something went wrong. Please try again.');
        console.error(err);
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner fullPage={false} />
      </div>
    );

  if (error)
    return (
      <div className="flex items-center justify-center min-h-screen text-red-600">
        {error}
      </div>
    );

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-3xl font-bold text-secondary">
          Income Records
        </h2>
        <button
          onClick={fetchIncomes}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
        >
          Refresh
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="overflow-x-auto">

          {incomes.length === 0 ? (
            <div className="p-10 text-center text-gray-500">
              No income records found.
            </div>
          ) : (
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">SR. No</th>

                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Type</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Amount</th>
                  {/* <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Status</th> */}
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Date</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {incomes.map((income, index) => (
                  <tr key={income._id || index} className="hover:bg-gray-50">
                    <td className="px-6 py-3 text-sm font-mono">{index + 1}</td>
                    <td className="px-6 py-3 text-sm font-mono">
                      {income.type?.replace(/_/g, ' ') || '-'}
                    </td>
                    <td className="px-6 py-3 text-sm font-semibold">
                      Rs. {income.amount?.toLocaleString() || 0}
                    </td>
                    {/* <td className="px-6 py-3 text-sm">
                      <span
                        className={`px-2 py-1 rounded text-xs ${
                          income.status === 'PAID'
                            ? 'bg-green-100 text-green-800'
                            : income.status === 'PENDING'
                            ? 'bg-yellow-100 text-yellow-800'
                            : 'bg-gray-100 text-gray-800'
                        }`}
                      >
                        {income.status || 'N/A'}
                      </span>
                    </td> */}
                    <td className="px-6 py-3 text-sm">
                      {income.createdAt
                        ? new Date(income.createdAt).toLocaleDateString()
                        : '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

        </div>
      </div>
    </div>
  );
};

export default UserIncome;